// pipe (ROMS+Monday P0.1): Reports sidebar entry (links to the Reports screen). Cloned from
// qms-button.tsx (verbatim shape) — only the route, the active-path prefix, the icon, the label
// key, and the testid differ. NOT admin-gated (the server Erp-gates the catalog + every run;
// the screen renders the localized load-error for a denied reader).
import { useI18n } from '@affine/i18n';
import { ExportIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const ReportsButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  // REACTIVE active state: any /reports route keeps the entry lit.
  const active = useNavPrefixActive(workbench, '/reports');

  return (
    <MenuLinkItem icon={<ExportIcon />} active={active} to={'/reports'}>
      <span data-testid="pipe-reports-nav">
        {t['com.affine.pipe.reports.nav']()}
      </span>
    </MenuLinkItem>
  );
};
